"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../utils.js";
import * as __rspack_external__radix_ui_react_collapsible_4aef300f from "@radix-ui/react-collapsible";
const Collapsible = __rspack_external__radix_ui_react_collapsible_4aef300f.Root;
const CollapsibleTrigger = __rspack_external__radix_ui_react_collapsible_4aef300f.CollapsibleTrigger;
const CollapsibleContent = /*#__PURE__*/ forwardRef(({ children, className }, ref)=>/*#__PURE__*/ jsx(__rspack_external__radix_ui_react_collapsible_4aef300f.CollapsibleContent, {
        ref: ref,
        className: cn(className, 'tw-overflow-hidden data-[state=open]:tw-animate-radix-slide-down data-[state=closed]:tw-animate-radix-slide-up'),
        children: children
    }));
export { Collapsible, CollapsibleContent, CollapsibleTrigger };
